import {lemon, lemonReady} from "../common/lemon";
import {
    buildRecommendTop5CardGifts,
    buildRecommendTop5EGifts,
    buildRecommendTop5Pamphlet, buildRecommendTop5QRGifts
} from "../common/recommend/recomment_goods";

lemonReady(function (){
  let recommendEGiftList = lemon("#recommendEGiftList");
  buildRecommendTop5EGifts({list_container: recommendEGiftList});
  let recommendCardGiftList = lemon("#recommendCardGiftList");
  buildRecommendTop5CardGifts({list_container: recommendCardGiftList});
  let recommendPamphletList = lemon("#recommendPamphletList");
  buildRecommendTop5QRGifts({list_container: recommendPamphletList});
});